import React from 'react';
import SimpleInput from '../SimpleInput';
import {isMobile} from "../../../services/Helpers";

const NumberQuestion = ({value, onChange, error, disabled}) => (
    <SimpleInput inputType="float" inputMode="decimal" width={isMobile ? '100%' : '10rem'} disabled={disabled} value={value ?? ''} onChangeCallback={(number) => onChange(number === null ? '' : String(number))} status={error ? 'error' : null} />
);

export default NumberQuestion;
